module.exports = "<app-board></app-board>\n"


//////////////////
// WEBPACK FOOTER
// /Users/philipeskins/Desktop/Epicodus/monopoly/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main